import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-cards',
    templateUrl: './block-cards.component.html',
})

export class BlockCardsComponent extends BlockAbstractComponent implements OnInit {

}
